"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

var _FormGroup = _interopRequireDefault(require("../FormGroup"));

var _Label = _interopRequireDefault(require("../Label"));

var _FormControlMessage = _interopRequireDefault(require("../FormControlMessage"));

var _FilesList = _interopRequireDefault(require("./FilesList"));

var _Upload = _interopRequireDefault(require("./Upload"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FileInput = function FileInput(_ref) {
  var label = _ref.label,
      labelInfobox = _ref.labelInfobox,
      uploadText = _ref.uploadText,
      disabled = _ref.disabled,
      required = _ref.required,
      error = _ref.error,
      multiple = _ref.multiple,
      children = _ref.children,
      onChange = _ref.onChange,
      defaultFileList = _ref.defaultFileList,
      rest = _objectWithoutProperties(_ref, ["label", "labelInfobox", "uploadText", "disabled", "required", "error", "multiple", "children", "onChange", "defaultFileList"]);

  var _useState = (0, _react.useState)(defaultFileList),
      _useState2 = _slicedToArray(_useState, 2),
      files = _useState2[0],
      setFiles = _useState2[1];

  var beforeUpload = function beforeUpload(file) {
    var newFilesList = [].concat(_toConsumableArray(files), [file]);
    setFiles(newFilesList);
    onChange(newFilesList);
    return false;
  };

  var handleChange = function handleChange(_ref2) {
    var fileList = _ref2.fileList;
    setFiles(fileList);
    onChange(fileList);
  };

  return /*#__PURE__*/_react.default.createElement(_FormGroup.default, {
    disabled: disabled,
    error: error
  }, label && /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: label,
    label: label,
    labelInfobox: labelInfobox,
    required: required
  }), /*#__PURE__*/_react.default.createElement(_FilesList.default, {
    files: files,
    onRemove: handleChange
  }), /*#__PURE__*/_react.default.createElement(_Upload.default, _extends({}, rest, {
    files: files,
    onChange: handleChange,
    beforeUpload: beforeUpload,
    disabled: disabled,
    multiple: multiple
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    type: "secondary",
    disabled: disabled
  }, uploadText)), error && /*#__PURE__*/_react.default.createElement(_FormControlMessage.default, null, error), children && /*#__PURE__*/_react.default.createElement("p", null, children));
};

exports.FileInput = FileInput;
FileInput.propTypes = {
  /** Text for action button */
  uploadText: _propTypes.default.string,

  /** The label text */
  label: _propTypes.default.string,

  /** The text displayed if the label tooltip exist */
  labelInfobox: _propTypes.default.bool,

  /** Whether the input is disabled */
  disabled: _propTypes.default.bool,

  /** If required field* */
  required: _propTypes.default.bool,

  /** Whether to support selected multiple file.
   * IE10+ supported. You can select multiple files with CTRL holding
   * down while multiple is set to be true */
  multiple: _propTypes.default.bool,

  /** The error message displayed if the input is errored */
  error: _propTypes.default.string,

  /** File types that can be accepted. */
  accept: _propTypes.default.string,

  /** @ignore */
  children: _propTypes.default.node,

  /** The default list files to display */
  defaultFileList: _propTypes.default.arrayOf(_propTypes.default.shape({
    uid: _propTypes.default.number,
    name: _propTypes.default.string
  })),

  /** The onChange event */
  onChange: _propTypes.default.func
};
FileInput.defaultProps = {
  uploadText: 'Browse',
  label: null,
  labelInfobox: false,
  disabled: false,
  required: false,
  multiple: false,
  error: null,
  accept: '*',
  children: null,
  defaultFileList: [],
  onChange: function onChange() {}
};
var _default = FileInput;
exports.default = _default;